import { component } from 'picoapp';

export default component(async (node) => {
  const { src } = node.dataset;

  const initObserver = () => {
    const observer = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting) {
        const { target } = entries[0];

        target.src = src;
        target.removeAttribute('data-src');

        observer.disconnect();
      }
    });

    observer.observe(node);
  };

  const init = () => {
    initObserver();
  };

  init();
});
